"use client";

import { useTranslations } from "next-intl";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("common");
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
        <h2 className="text-lg font-bold text-red-600">
          {t("errorBoundaryTitle")}
        </h2>
        <p className="mt-2 text-sm text-gray-600">{error.message}</p>

        <div className="flex justify-end mt-4 gap-2">
          <button
            onClick={() => reset()}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            {t("errorBoundaryBtn")}
          </button>
        </div>
      </div>
    </div>
  );
}
